import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { isGranted } from 'common/helpers.ts';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import type { Leg } from 'services/types/src/Leg.ts';
import type { Shipment } from 'types/Shipment.ts';
import { IDelete, IDots, IEye, IUser } from 'ui/component/Icons.tsx';
import { useMe } from '#admin/hook/useMe.tsx';

type Props = {
  activeLeg?: Leg;
  shipment: Shipment;
  onClickDriverAssign?: () => void;
  onClickDelete: () => void;
};

export const ShipmentListItemMenu: React.FC<Props> = ({ activeLeg, shipment, onClickDriverAssign, onClickDelete }) => {
  const { t } = useTranslation();
  const { me } = useMe();
  const legs = shipment.legs;
  if (!me) return null;

  const isMultipleLegs = legs.length > 1;
  const driver = legs[0]?.driver;

  // WORKAROUND: bypass permission hierarchy for performance reasons
  // const canAssignDriver = isGranted(me, 'LegAssignDriver', activeLeg.id) || isGranted(me, 'LegAssignDriver', activeLeg.owner_id);
  const canAssignDriver = activeLeg && (activeLeg.supplier_id === me?.owner_id || isGranted(me, '*', '*'));

  return (
    <Menu>
      <MenuButton className="flex size-full place-content-center place-items-center" data-table-no-row-events>
        <IDots className="text-gray-400" size={28} data-table-no-row-events />
      </MenuButton>
      <MenuItems className="row-menu" anchor="bottom end">
        {shipment.state !== 'draft' && shipment.state !== 'cancelled' && (
          <>
            <MenuItem>
              <Link className="contents" to={`/shipment/${shipment.id}`}>
                <button className="row-menu-item">
                  <IEye size={20} />
                  {t('actions.view')}
                </button>
              </Link>
            </MenuItem>
            {/* @tofix: We need to know which leg it is to enforce it at leg-level */}
          </>
        )}
        {canAssignDriver && shipment.state !== 'draft' && shipment.state !== 'cancelled' && (
          <>
            {!isMultipleLegs && (
              <button
                className="row-menu-item cursor-pointer"
                onClick={() => {
                  // this can't be outside here (eg: handler function) because of the portal
                  close();
                  onClickDriverAssign?.();
                }}
              >
                <IUser size={20} />
                {driver ? t('actions.reassign') : t('actions.assign')}
              </button>
            )}
            {isMultipleLegs && (
              <Link className="contents" to={`/shipment/${shipment.id}`}>
                <button className="row-menu-item cursor-pointer">
                  <IUser size={20} />
                  {driver ? t('actions.reassign') : t('actions.assign')}
                </button>
              </Link>
            )}
          </>
        )}
        <MenuItem>
          <button className="!border-0 row-menu-item" onClick={onClickDelete}>
            <IDelete size={20} />
            {t('actions.delete')}
          </button>
        </MenuItem>
      </MenuItems>
    </Menu>
  );
};
